import { render, staticRenderFns } from "./BookingPayments.vue?vue&type=template&id=f156c16c&scoped=true&"
import script from "./BookingPayments.vue?vue&type=script&lang=ts&"
export * from "./BookingPayments.vue?vue&type=script&lang=ts&"
import style0 from "./BookingPayments.vue?vue&type=style&index=0&id=f156c16c&scoped=true&lang=scss&"
import style1 from "./BookingPayments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f156c16c",
  null
  
)

export default component.exports